import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../utils/axiosInstance";

const UmutekanoLogin = () => {
  const [national_id, setNationalId] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!national_id.trim() || !password.trim()) {
      setError("Shyiramo indangamuntu na password");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("/login_umutekano", {
        national_id: national_id.replace(/\s/g, ""),
        password,
      });
      const { token, role, user_id, fullname, umudugudu_id } = res.data;
      localStorage.setItem("token", token);
      if (user_id) localStorage.setItem("user_id", String(user_id));
      if (role) localStorage.setItem("role", role);
      if (fullname) localStorage.setItem("fullname", fullname);
      if (umudugudu_id) localStorage.setItem("umudugudu_id", String(umudugudu_id));
      navigate("/umutekano/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || "Kwinjira ntibyakunze");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.iconWrap}>
            <i className="bi bi-shield-lock-fill" style={{ fontSize: "1.6rem", color: "#fff" }} />
          </div>
          <h1 style={styles.title}>Umutekano</h1>
          <p style={styles.subtitle}>Injira muri sisitemu y'Umutekano</p>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Numero y'Irangamuntu</label>
            <div style={styles.inputWrap}>
              <i className="bi bi-card-text" style={styles.inputIcon} />
              <input
                type="text"
                value={national_id}
                onChange={(e) => setNationalId(e.target.value)}
                placeholder="119 cyangwa 120..."
                maxLength={16}
                inputMode="numeric"
                autoComplete="off"
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Ijambo ry'ibanga</label>
            <div style={styles.inputWrap}>
              <i className="bi bi-lock" style={styles.inputIcon} />
              <input
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{ ...styles.input, paddingRight: "3rem" }}
              />
              <button type="button" onClick={() => setShowPwd(!showPwd)} style={styles.eyeBtn}>
                <i className={`bi bi-eye${showPwd ? "-slash" : ""}-fill`} />
              </button>
            </div>
          </div>

          {error && (
            <div style={styles.errorBox}>
              <i className="bi bi-exclamation-triangle-fill" style={{ marginRight: 6 }} />
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Tegereza...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-2" />
                Injira
              </>
            )}
          </button>
        </form>

        <button onClick={() => navigate("/")} style={styles.backBtn}>
          <i className="bi bi-arrow-left me-1" /> Gusubira
        </button>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0a0e1a 0%, #1a1a3e 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem",
  },
  card: {
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(108,99,255,0.2)",
    borderRadius: 24,
    padding: "2.5rem 2rem",
    width: "100%",
    maxWidth: 420,
    boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
  },
  header: { textAlign: "center", marginBottom: "2rem" },
  iconWrap: {
    width: 64,
    height: 64,
    borderRadius: 18,
    background: "linear-gradient(135deg, #6c63ff, #4f46e5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1rem",
    boxShadow: "0 8px 24px rgba(108,99,255,0.4)",
  },
  title: {
    fontSize: "2rem",
    fontWeight: 800,
    color: "#fff",
    margin: 0,
    letterSpacing: "-0.02em",
  },
  subtitle: { color: "rgba(255,255,255,0.6)", fontSize: "0.9rem", marginTop: 4 },
  form: { display: "flex", flexDirection: "column", gap: "1.25rem" },
  field: { display: "flex", flexDirection: "column", gap: 6 },
  label: { color: "rgba(255,255,255,0.85)", fontWeight: 600, fontSize: "0.9rem" },
  inputWrap: { position: "relative" },
  inputIcon: {
    position: "absolute",
    left: "1rem",
    top: "50%",
    transform: "translateY(-50%)",
    color: "rgba(255,255,255,0.45)",
    fontSize: "1.1rem",
    pointerEvents: "none",
  },
  input: {
    width: "100%",
    background: "rgba(0,0,0,0.3)",
    border: "1px solid rgba(108,99,255,0.2)",
    borderRadius: 14,
    color: "#fff",
    padding: "0.9rem 1rem 0.9rem 3rem",
    fontSize: 16,
    outline: "none",
    boxSizing: "border-box",
  },
  eyeBtn: {
    position: "absolute",
    right: "0.75rem",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    color: "rgba(255,255,255,0.5)",
    cursor: "pointer",
    fontSize: "1.1rem",
    padding: "4px 8px",
  },
  errorBox: {
    background: "rgba(239,68,68,0.12)",
    border: "1px solid rgba(239,68,68,0.3)",
    borderRadius: 12,
    color: "#fca5a5",
    padding: "0.75rem 1rem",
    fontSize: "0.85rem",
  },
  btn: {
    background: "linear-gradient(135deg, #6c63ff, #4f46e5)",
    border: "none",
    borderRadius: 14,
    color: "#fff",
    fontWeight: 700,
    fontSize: "1rem",
    padding: "0.9rem",
    cursor: "pointer",
    marginTop: "0.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 52,
    boxShadow: "0 6px 20px rgba(108,99,255,0.35)",
  },
  backBtn: {
    display: "block",
    width: "100%",
    marginTop: "1rem",
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: 12,
    color: "rgba(255,255,255,0.6)",
    padding: "0.6rem",
    cursor: "pointer",
    fontSize: "0.88rem",
    textAlign: "center",
  },
};

export default UmutekanoLogin;
